import RoleService from "@/api/services/roleService";
import { getCookie, setCookie } from "@/utils/cookies";
import { DISABLED_ROLES_COOKIE } from "@/utils/variables";
import { Role } from "@/interfaces/Role.ts";
import { defineStore } from "pinia";

interface RoleState {
  roles: Role[];
  disabledRoles: string[];
}

export const useRoleStore = defineStore("role", {
  state: (): RoleState => ({
    roles: [],
    disabledRoles: [],
  }),

  getters: {
    getAll: (state: RoleState) => state.roles,
    isDisabled: (state: RoleState) => (token: string) => state.disabledRoles.indexOf(token) !== -1,
    hasRole: (state: RoleState) => (token: string) => {
      const enabled = [...state.roles];

      state.disabledRoles.forEach((token) => {
        enabled.splice(enabled.map((role) => role.token).indexOf(token), 1);
      });

      return enabled.map((role) => role.token).indexOf(token) !== -1;
    },
  },

  actions: {
    async load() {
      this.roles = await RoleService.getRoles();

      const disabled = getCookie(DISABLED_ROLES_COOKIE);
      this.disabledRoles = disabled ? disabled.split(",") : [];
    },
    toggleRole(token: string) {
      const disabled = this.disabledRoles || [];

      if (!disabled.includes(token)) {
        disabled.push(token);
      } else {
        disabled.splice(disabled.indexOf(token), 1);
      }

      this.disabledRoles = disabled;
      setCookie(DISABLED_ROLES_COOKIE, disabled.join(","), 14);
    },
  },
});
